(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var cartPage = document.querySelector('.cart-page');
    if (!cartPage) return;

    /* Title click → navigate home (triggers tabToHomeTransition) */
    var title = cartPage.querySelector('.cart-page__title');
    if (title) {
      title.addEventListener('click', function () {
        if (window.barba) {
          window.barba.go('/');
        } else {
          window.location.href = '/';
        }
      });
    }

    cartPage.addEventListener('click', async function (e) {
      var btn = e.target.closest('[data-delta]');
      if (!btn) return;

      var variantId = btn.dataset.variantId;
      var delta = parseInt(btn.dataset.delta, 10);
      if (!variantId || isNaN(delta)) return;

      btn.disabled = true;

      var notice = cartPage.querySelector('.cart-page__notice');
      function hideNotice() { if (notice) { notice.hidden = true; notice.textContent = ''; } }
      function showNotice(msg) { if (notice) { notice.textContent = msg || (notice.dataset.defaultMessage || 'Could not update quantity.'); notice.hidden = false; } }

      hideNotice();

      try {
        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();
        var item = cart.items.find(function (i) {
          return String(i.variant_id) === String(variantId);
        });
        var currentQty = item ? item.quantity : 0;
        var newQty = Math.max(0, currentQty + delta);

        var changeRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: newQty }),
        });

        if (!changeRes.ok) {
          var errData = await changeRes.json().catch(function () { return {}; });
          throw new Error(errData.description || errData.message || 'Could not update quantity.');
        }

        window.location.reload();
      } catch (err) {
        console.warn('[CartPage] qty update failed', err);
        showNotice(err && err.message ? err.message : null);
        btn.disabled = false;
      }
    });

    cartPage.addEventListener('click', async function (e) {
      var removeLink = e.target.closest('.cart-ditem__remove');
      if (!removeLink) return;

      e.preventDefault();
      removeLink.style.opacity = '0.4';
      removeLink.style.pointerEvents = 'none';

      try {
        var lineKey = removeLink.dataset.lineKey;

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });

        window.location.reload();
      } catch (err) {
        console.warn('[CartPage] remove failed', err);
        removeLink.style.opacity = '';
        removeLink.style.pointerEvents = '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (function () {
    // Intentionally empty. Site-by behavior is CSS-only:
    // desktop = hover reveal, mobile = static text + logo.
  })();

  } catch(e) { console.error(e); }
})();
})();
